module.exports = __webpack_public_path__ + "img/img-1.fc98d12b.webp";